import AbstractService from "./Abstract.service";

export default class LottoService extends AbstractService
{
    listing(): Promise<any>
    {
        return this.get('/lotok/th');
    }

    process(model:any): Promise<any>
    {
        return this.post('/process', model);
    }

    result(model:any): Promise<any>
    {
        return this.post('/lotok/result', model);
    }

    zoneAll(): Promise<any>
    {
        return this.get('/lotok/zone/all/1');
    }

    moneyLotto(p_ok_id,p_mcut,p_namecut, p_mset): Promise<any>
    {
        return this.get(`/moeny/lotto?p_ok_id=${p_ok_id}&p_mcut=${p_mcut}&p_mset=${p_mset}&p_lot_zone=1&p_namecut=${p_namecut}`);
    }

    user(p_ok_id,p_mset,p_number, p_lot_type): Promise<any>
    {
        return this.get(`/moeny/lotto/user?p_ok_id=${p_ok_id}&p_mset=${p_mset}&p_lot_zone=1&p_number=${p_number}&p_lot_type=${p_lot_type}`);
    }

    reBill(model:any): Promise<any>
    {
        return this.post('/rebill', model);
    }

    control(model:any): Promise<any>
    {
        return this.post('/control', model);
    }

}
